import React from "react";
import bannerUltragazEnergia from "assets/images/NewBannerUltragazEnergia.png";

import {
  BannerUltragazEnergia,
  ContentBannerUltragazEnergia,
  LinkBannerUltragazEnergia,
} from "./styles";

const BannerEnergia: React.FC = () => {
  return (
    <ContentBannerUltragazEnergia>
      <LinkBannerUltragazEnergia to="ultragaz-energia">
        <BannerUltragazEnergia src={bannerUltragazEnergia} />
      </LinkBannerUltragazEnergia>
    </ContentBannerUltragazEnergia>
  );
};

export default BannerEnergia;
